import React from "react";
import TemplateInputName from '../inputs/TemplateInputName';
import TemplateInputPosition from '../inputs/TemplateInputPosition';
import Logo from './Logo';
import TemplateZoomBack from '../layout/TemplateZoomBack';

const TemplatePreview = (props) => {
  var template = props.template;
  
  const styleObj = { backgroundColor: '' }
  const nameStyleObj = {
    marginLeft: '90px',
    paddingLeft: 0,
    color: ''
  }
  const positionStyleObj = {
    fontSize: '1.5em',
    marginLeft: '90px',
    paddingLeft: 0,
    color: ''
  }
  const logoStyleObj = {
    textAlign: 'right',
    paddingRight: 0,
    color: ''
  }
  var toggleWatermark = 'zoomback';
  var watermarkColor = '#ffffff';
  if (template !== undefined) {
    var logo = template.logo;
    var logoWidth = template.logoWidth;
    var dropdown = template.dropdown;
    styleObj.backgroundColor = template.backgroundColor;
    styleObj['--placeholder-color'] = template.textColor;
    nameStyleObj.color = template.textColor;
    positionStyleObj.color = template.textColor;
    logoStyleObj.color = template.logoColor;
    watermarkColor = template.logoColor;
    if (template.watermarkHidden) {
      toggleWatermark = "zoomback zoomback-hide";
    }
  }
  return (
    <div className="image-preview" style={styleObj}>
      <div className="image-preview-editable">
        <div className="image-preview-name">
          <TemplateInputName nameStyleObj={nameStyleObj} />
          <TemplateInputPosition positionStyleObj={positionStyleObj} />
        </div>
        <div className="image-preview-logo">
          <Logo logo={logo} logoWidth={logoWidth} dropdown={dropdown} logoStyleObj={logoStyleObj}/>
        </div>
      </div>
      <div className={toggleWatermark}>
        <TemplateZoomBack color={watermarkColor}/>
      </div>
    </div>
  )
};

export default TemplatePreview;
